module.exports = {
    log_in: "Log in",
    language_select: "Language"
}